module.exports = __webpack_public_path__ + "static/media/stofferingen-40.873b6cf6.jpg";